module.exports = __webpack_public_path__ + "media/images/bg-f19a844f795c3dff50bcff04d19e62b8.jpg";